var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconStatusGold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 16.77,
    y1: 20.07,
    x2: 6.82,
    y2: 0.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbcb35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fea40d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 16.56,
    y1: 17.95,
    x2: -1.17,
    y2: -10.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa916"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fc6a06"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.39,23l-1.78-7.09H7.39L5.61,23a.84.84,0,0,0,1.08,1L12,22.17,17.31,24A.84.84,0,0,0,18.39,23Z",
    fill: "#fd6a34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.75,14.53V6.87a3,3,0,0,0-1.51-2.61L13.49.41a3,3,0,0,0-3,0L3.76,4.26A3,3,0,0,0,2.25,6.87v7.66a3,3,0,0,0,1.51,2.6L10.51,21a3,3,0,0,0,3,0l6.75-3.86A3,3,0,0,0,21.75,14.53Z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,19.93a3.37,3.37,0,0,1-1.69-.45L5.19,16.56a3.42,3.42,0,0,1-1.72-3V7.8a3.41,3.41,0,0,1,1.72-3l5.12-2.93a3.4,3.4,0,0,1,3.38,0l5.12,2.93a3.41,3.41,0,0,1,1.72,3v5.8a3.42,3.42,0,0,1-1.72,3l-5.12,2.92A3.37,3.37,0,0,1,12,19.93ZM12,2.44a2.46,2.46,0,0,0-1.21.32L5.67,5.68A2.46,2.46,0,0,0,4.44,7.8v5.8a2.45,2.45,0,0,0,1.23,2.11l5.12,2.93a2.48,2.48,0,0,0,2.42,0l5.12-2.93a2.45,2.45,0,0,0,1.23-2.11V7.8a2.46,2.46,0,0,0-1.23-2.12L13.21,2.76A2.46,2.46,0,0,0,12,2.44Z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.41,5.91l1.07,2.41a.47.47,0,0,0,.37.27l2.62.27a.45.45,0,0,1,.26.78l-2,1.77a.45.45,0,0,0-.14.42l.55,2.59a.45.45,0,0,1-.66.48l-2.29-1.32a.43.43,0,0,0-.44,0L9.49,14.9a.45.45,0,0,1-.66-.48l.55-2.59a.45.45,0,0,0-.14-.42l-2-1.77a.45.45,0,0,1,.26-.78l2.62-.27a.47.47,0,0,0,.37-.27l1.07-2.41A.45.45,0,0,1,12.41,5.91Z",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStatusGold);
export default __webpack_public_path__ + "static/media/icon-status-gold.e6a22b82c7a0a5c5d4d09dfb529513ae.svg";
export { ForwardRef as ReactComponent };